const translations = {
  title: 'New Activity',
  title_edit: 'Editing Activity',
  title_reopening: 'Reopening Activity',
  bulkRegistration: 'Bulk registration',
  name: 'Name',
  checklist: 'Checklist*',
  placeType: 'Destination type',
  place: 'Destination*',
  asset: 'Asset',
  responsible: 'Responsible',
  address: 'Address',
  scheduling: 'Scheduling date',
  priority: 'Priority',
  tag: 'Tag',
  lockReasons: 'Block reasons',
  additionalFields: 'Additional fields',
  description: 'Description',
  addFile: 'Add File'
}

export default translations
